module.exports = __webpack_public_path__ + "static/3-2be0130a6397b640b800938819ff2a85.jpg";